export default __webpack_public_path__ + "static/media/31.7a1a75ae.jpg";